// Abstract datamodel to perform basic actions on objects stored in store
class AbstractModel {
  //- Constructor
  constructor(data) {
    this.data = data
  }

  //- Setter
  set(data){
    this.data = data
  }

  //- Getter
  get(){
    return this.data
  }

  //- Get Id
  getId(){ 
    return (this.data ? this.data.id : null)
  }
}

export default AbstractModel